import Image from "next/image";
import Link from "next/link";

import { ROUTES } from "@/helpers/routes";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../shared/components/layout";

export default function Supporters() {

    return (
        <div>
            <PageSeo title="Our Dedicated Supporters | The Gender Index" pathname={ROUTES.supporters}/>
            <Layout>
                <div className='singleLayout type2 supporterPage'>
                    <h3>
                        Supporters
                    </h3>
                    <p className='body-default-copy-large'>Thank you to all our sponsors who help support The Gender Index, please follow their logos to learn more</p>
                    <div className='flexDv'>
                        <div className='mb16'>
                            <ul className='commonList supportersLogos'>
                                <li>
                                    <Link href="https://www.bl.uk/" target="_blank">
                                        {/* <img src="/images/supporters/BIPC_London_with-BL-Logo-336x131.png" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/BIPC_London_with-BL-Logo-336x131.png"
                                            alt="company_logo"
                                            width={102}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://www.coast2capital.org.uk/" target="_blank">
                                        {/* <img src="/images/supporters/coast_to_capital-316x156.png" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/coast_to_capital-316x156.png"
                                            alt="company_logo"
                                            width={81}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://diversesussex.com/" target="_blank">
                                        {/* <img src="/images/supporters/Diverse-Sussex-logo-259x156.png" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/Diverse-Sussex-logo-259x156.png"
                                            alt="company_logo"
                                            width={66}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/" target="_blank">
                                        {/* <img src="/images/supporters/england-vector-map-blank-map-png-favpng-0pUH4W7XBJYpPWTSDvAarVqRB.jpg" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/england-vector-map-blank-map-png-favpng-0pUH4W7XBJYpPWTSDvAarVqRB.jpg"
                                            alt="company_logo"
                                            width={40}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://www.enterthearena.co.uk/" target="_blank">
                                        {/* <img src="/images/supporters/Enter-the-arena-336x87.png" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/Enter-the-arena-336x87.png"
                                            alt="company_logo"
                                            width={154}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://www.enterpriseresearch.ac.uk/" target="_blank">
                                        {/* <img src="/images/supporters/ERC_Logo_RGB-336x144.jpg" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/ERC_Logo_RGB-336x144.jpg"
                                            alt="company_logo"
                                            width={93}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://www.everywoman.com/" target="_blank">
                                        {/* <img src="/images/supporters/everywoman-Logo-jpeg-336x123.jpg" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/everywoman-Logo-jpeg-336x123.jpg"
                                            alt="company_logo"
                                            width={109}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>

                                <li>
                                    <Link href="https://www.fintechscotland.com/" target="_blank">
                                        {/* <img src="/images/supporters/Fintech-Logo-2020-RGB_SML-336x90.png" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/Fintech-Logo-2020-RGB_SML-336x90.png"
                                            alt="company_logo"
                                            width={149}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://www.icaew.com/" target="_blank">
                                        {/* <img src="/images/supporters/ICAEW-logo-small-294x156.png" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/ICAEW-logo-small-294x156.png"
                                            alt="company_logo"
                                            width={75}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://www.iod.com/" target="_blank">
                                        {/* <img src="/images/supporters/IoD_Master-Logo_Mono_CMYK_IoD_K-1-177x156.jpg" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/IoD_Master-Logo_Mono_CMYK_IoD_K-1-177x156.jpg"
                                            alt="company_logo"
                                            width={45}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://isbe.org.uk/" target="_blank">
                                        {/* <img src="/images/supporters/isbe-logo-336x104.png" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/isbe-logo-336x104.png"
                                            alt="company_logo"
                                            width={129}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://www.savvitas.com/" target="_blank">
                                        {/* <img src="/images/supporters/Savvitas_400_color_s-156x156.png" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/Savvitas_400_color_s-156x156.png"
                                            alt="company_logo"
                                            width={40}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://steeryourbusiness.com/" target="_blank">
                                        {/* <img src="/images/supporters/steer-156x156.png" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/steer-156x156.png"
                                            alt="company_logo"
                                            width={40}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://thedatalab.com/" target="_blank">
                                        {/* <img src="/images/supporters/The-Data-Lab-logo-336x107.jpg" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/The-Data-Lab-logo-336x107.jpg"
                                            alt="company_logo"
                                            width={125}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://weconnectinternational.org/" target="_blank">
                                        {/* <img src="/images/supporters/wec-logo.png" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/wec-logo.png"
                                            alt="company_logo"
                                            width={158}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://www.wescotland.co.uk/" target="_blank">
                                        {/* <img src="/images/supporters/WES_NEW.png" alt="company_logo" /> */}
                                        <Image
                                            src="/images/supporters/WES_NEW.png"
                                            alt="company_logo"
                                            width={106}
                                            height={40}
                                            loading="lazy"
                                        />
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </Layout>
        </div>
    );
}

